module.exports = "<form class=\"form\" #modalForm=\"ngForm\" enctype=\"multipart/form-data\">\r\n\r\n  <div class=\"container-grid\">\r\n    <ag-grid-angular\r\n      #agGrid1\r\n      class=\"height height-500\"\r\n      [gridOptions]=\"logGrid\"\r\n      [enableSorting]=\"true\">\r\n    </ag-grid-angular>\r\n  </div>\r\n\r\n</form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/on-demand-drivers/components/logs/logs.component.html
// module id = 2482
// module chunks = 66